import styled from 'styled-components';
import Select from 'react-select';
import { Colors, Styling } from '../../constants';

export const SelectClass = 'AssetFieldSelect';

const StyledSelect = styled(Select).attrs({
  classNamePrefix: SelectClass,
})`
  margin-top: ${Styling.DEFAULT_SPACING_DOUBLED}px;
  .${SelectClass}__control {
    min-width: fill-available;
    width: 100%;
    background-color: transparent;
    border: 0;
    border-radius: 0;
    border-bottom-width: 1px;
    border-color: ${Colors.BLACK_42};
    border-style: solid;
    &:after {
      flex-basis: 100%;
      content: " ";
      border-bottom: 1px solid transparent;
    }
    &:hover {
      &:after {
        border-bottom: none;
      }
      border-bottom-width: 2px;
      border-color: ${Colors.BLACK_100};
    }
    &.${SelectClass}__control--is-disabled {
      border-style: dotted;
      .${SelectClass}__value-container--is-multi .${SelectClass}__multi-value {
        .${SelectClass}__multi-value__label {
          padding-left: 3px;
        }
        .${SelectClass}__multi-value__remove {
          display: none;
        }
      }
    }
    &.${SelectClass}__control--is-focused {
      box-shadow: none;
      border-bottom: 2px solid ${Colors.RED_1};
    }
  }
`;

export default StyledSelect;
